import { useState } from "react";
import { createCommodityCode, updateCommodityCode } from "../../../../api/commodity-codes";
import InputsSection from "../../../common/InputsSection/InputsSection";
import { defaultCommodityCodesElements } from "../../../../pages/CommodityCodes";
import SectionSearch from "../SectionsSearch/SectionsSearch";
import SectionActions from "./components/SectionActions";
import NotificationToast from "../../../common/NotificationToast";

const CommodityCodes = (props) => {
	const [saveConfirmation, setSaveConfirmation] = useState(false);
	const [inputValues, setInputValues] = useState({});
	const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
	const [searchValue, setSearchValue] = useState("");
	const [isSaveLoading, setIsSaveLoading] = useState(false);
	const [isUpdateLoading, setIsUpdateLoading] = useState(false);
	const { itemIndex } = props;

	const handleUpdateExistingClick = async () => {
		if (!inputValues.id) return;
		setIsUpdateLoading(true);

		const { id, ...data } = inputValues;
		try {
			await updateCommodityCode(id, data);
		} catch (e) {
			console.log(e);
		}
		setIsUpdateLoading(false);
	};

	const handleSaveClick = async () => {
		setIsSaveLoading(true);
		try {
			const result = await createCommodityCode(inputValues);

			setInputValues({
				...inputValues,
				id: result.items && result.items[0] ? result.items[0].creationTime : inputValues.id,
			});
			setSaveConfirmation(true);
			setIsSaveLoading(false);
		} catch (e) {
			console.log(e);
		}
	};

	const handleClearClick = () => {
		setInputValues({});
	};

	const handleSearchSelection = (data) => {
		setInputValues({ ...data });
		setIsSearchModalOpen(false);
	};

	return (
		<div>
			<NotificationToast
				open={saveConfirmation}
				handleClose={() => setSaveConfirmation(false)}
				text="Commodity Code saved successfully"
			/>

			<InputsSection
				title="Commodity Codes"
				section="commodityCodes"
				styleName="lemon"
				fullWidth={true}
				SectionActions={
					<SectionSearch
						searchType="commodityCodes"
						onSearchInputChange={(e) => setSearchValue(e.target.value)}
						searchValue={searchValue}
						setIsSearchModalOpen={setIsSearchModalOpen}
						isSearchModalOpen={isSearchModalOpen}
						searchResultElements={defaultCommodityCodesElements}
						onAddClick={handleSearchSelection}
					/>
				}
				elements={[
					{
						type: "multiline",
						elementName: "commodityCodes",
						inputValues,
						setInputValues,
						ActionsComponent: (
							<SectionActions
								hideUpdateExisting
								hideClearButton
								inputValues={inputValues}
								isUpdateLoading={isUpdateLoading}
								isSaveLoading={isSaveLoading}
								onUpdateExistingClick={handleUpdateExistingClick}
								onClearClick={handleClearClick}
								onSaveClick={handleSaveClick}
							/>
						),
					},
				]}
				itemIndex={itemIndex}
			/>
		</div>
	);
};

export default CommodityCodes;
